import Toastify from 'toastify-js'

const showToastify = (message, opts) => {
	Toastify({
		duration: 3000,
		position: "center",
		style: { background: "black" },
		text: message,
		...opts
	}).showToast();
}

export default showToastify